import React from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import '../styles/error.css';

function ErrorBarcode() {
  const navigate = useNavigate();
  const { po_number, cart_code, sku_code, rack_shelf } = useParams();
  const location = useLocation();

  // Recupera el estado del código de barras esperado y el formato_unit_kg desde la navegación
  const { expectedBarcode, formatUnitKg, scannedValue } = location.state || {};

  const handleRescan = () => {
    // Redirige a la URL de escaneo con los parámetros
    navigate(`/picker/${po_number}/${cart_code}/${sku_code}/${rack_shelf}`);
  };

  return (
    <div className="error-page">
      <h2 className="error-title">No es el código de barras esperado</h2>
      {formatUnitKg === false && expectedBarcode ? (
        <p className="expected-barcode">
          Código de barras esperado: <strong style={{ userSelect: 'none', WebkitUserSelect: 'none' }}>{expectedBarcode}</strong>
        </p>
      ) : (
        <p className="default-message">
          Por favor, verifica el código y vuelve a intentarlo.
        </p>
      )}
      {scannedValue && (
        <p className="expected-barcode">
          Código escaneado: <strong>{scannedValue}</strong>
        </p>
      )}
      <button onClick={handleRescan} className="error-button">
        Volver a escanear
      </button>
    </div>
  );
}

export default ErrorBarcode;
